import type { ReactNode } from 'react'
import React from 'react'

import { useMediaQueryContext } from '@fourthwall/components'
import type { SubscriptionsAnalyticsSource } from '@modules/Dashboard/modules/Subscriptions'
import { UpgradeSubscriptionButton } from '@modules/Dashboard/modules/Subscriptions'

import * as S from './UpgradeSubscriptionBanner.styled'
import type { UpgradeSubscriptionBannerLayout } from './UpgradeSubscriptionBanner.types'

export type UpgradeSubscriptionBannerProps = {
  children: ReactNode
  layout?: UpgradeSubscriptionBannerLayout
  source?: SubscriptionsAnalyticsSource
  buttonLabel?: string
  onClick?: () => void
}

export const UpgradeSubscriptionBanner = ({
  children,
  layout = 'horizontal',
  source,
  buttonLabel,
  onClick,
}: UpgradeSubscriptionBannerProps) => {
  const media = useMediaQueryContext()

  return (
    <S.Container $layout={layout}>
      <S.ContentContainer>{children}</S.ContentContainer>
      <UpgradeSubscriptionButton
        label={buttonLabel}
        source={source}
        fullWidth={!media.tablet || layout === 'vertical'}
        onClick={onClick}
      />
    </S.Container>
  )
}
